import { computed } from 'vue';
import { FormItemRule } from 'element-plus';
import { storeToRefs } from 'pinia';
import { documentListFilterFormRef, useDocumentListFilterStore } from '@/store/documents/document-filter-list.store';
import { DocumentListFilter } from '@/models/documents/document-list-filter.model';

export const useDocumentListFilterFormRules = () => {
  const {
    isFilterTagIdListNotEmpty,
    isFilterSegmentIdListNotEmpty,
    isFilterCountryListNotEmpty,
    documentListFilterFormData,
  } = storeToRefs(useDocumentListFilterStore());

  const rulesProperty: FormItemRule = {
    message: 'Required',
    trigger: ['change', 'blur'],
  };

  const clearConditionValidation = (prop: keyof DocumentListFilter): void => {
    documentListFilterFormRef.value?.clearValidate(prop);
  };

  const minTotalAmountEurValidation = (_rule: unknown, value: string, callback: Function) => {
    const min = Number(value);
    const max = Number(documentListFilterFormData.value.maxTotalAmountEur);

    if (!value || !documentListFilterFormData.value.maxTotalAmountEur) {
      callback();

      return;
    }

    if (min > max) {
      callback(new Error('Min cannot exceed Max.'));

      return;
    }

    callback();
  };

  const maxTotalAmountEurValidation = (_rule: unknown, value: string, callback: Function) => {
    const min = Number(documentListFilterFormData.value.minTotalAmountEur);
    const max = Number(value);

    if (!value || !documentListFilterFormData.value.minTotalAmountEur) {
      callback();

      return;
    }

    if (max < min) {
      callback(new Error('Max cannot be less than Min.'));

      return;
    }

    callback();
  };

  const documentListFilterFormRules = computed<Record<string, FormItemRule[]>>(() => {
    return {
      countryListCondition: [{
        ...rulesProperty,
        required: isFilterCountryListNotEmpty.value,
      }],
      segmentIdListCondition: [{
        ...rulesProperty,
        required: isFilterSegmentIdListNotEmpty.value,
      }],
      tagIdListCondition: [{
        ...rulesProperty,
        required: isFilterTagIdListNotEmpty.value,
      }],
      minTotalAmountEur: [{
        validator: minTotalAmountEurValidation,
        trigger: ['change', 'blur'],
      }],
      maxTotalAmountEur: [{
        validator: maxTotalAmountEurValidation,
        trigger: ['change', 'blur'],
      }],
    };
  });

  return {
    documentListFilterFormRules,
    clearConditionValidation,
  };
};
